import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconFittingM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 14 7" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M 7.2929 4 L 0.5 4 C 0.2239 4 0 3.7761 0 3.5 C 0 3.2239 0.2239 3 0.5 3 L 7.2929 3 L 5.1464 0.8536 C 4.9512 0.6583 4.9512 0.3417 5.1464 0.1464 C 5.3417 -0.0488 5.6583 -0.0488 5.8536 0.1464 L 8.8536 3.1464 C 8.9473 3.2402 9 3.3674 9 3.5 C 9 3.6326 8.9473 3.7598 8.8536 3.8536 L 5.8536 6.8536 C 5.6583 7.0488 5.3417 7.0488 5.1464 6.8536 C 4.9512 6.6583 4.9512 6.3417 5.1464 6.1464 L 7.2929 4 Z M 14 3.5 C 14 2.3954 13.1046 1.5 12 1.5 C 10.8954 1.5 10 2.3954 10 3.5 C 10 4.6046 10.8954 5.5 12 5.5 C 13.1046 5.5 14 4.6046 14 3.5 Z" />
  </svg>
)

export const IconFitting = createIcon({
  name: 'IconFitting',
  l: IconFittingM,
  m: IconFittingM,
  s: IconFittingM,
  xs: IconFittingM,
})
